import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, withModifiers as _withModifiers, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "watchlist-item__image" };
const _hoisted_2 = ["src", "alt"];
const _hoisted_3 = { class: "watchlist-item__article" };
const _hoisted_4 = { class: "watchlist-item__sku" };
const _hoisted_5 = { class: "watchlist-item__controls" };
const _hoisted_6 = {
    key: 0,
    class: "watchlist-item__cart-form"
};
const _hoisted_7 = {
    key: 0,
    class: "watchlist-item-controls__unit"
};
const _hoisted_8 = ["title"];
const _hoisted_9 = { class: "watchlist-item__actions" };
import { ref, watch } from 'vue';
import { debounce } from 'lodash';
import productUtils from '@astina/paloma-shop-common-ui/src/services/ProductUtils';
import ArticleQuantityInput from "@astina/paloma-shop-common-ui/src/components/ArticleQuantityInput.vue";
import { addCartItem } from "../commands/AddCartItems";
import { updateWatchlistItem } from "../commands/UpdateWatchlistItem";
import CommandButton from "@astina/paloma-common-ui/src/components/CommandButton.vue";
import { isGranted } from "@astina/paloma-common-ui/src/services/AccessManager";
import RemoveWatchlistItems from "../commands/RemoveWatchlistItems";
import WatchlistUtils from "../services/WatchlistUtils";
import events from "@astina/paloma-common-ui/src/services/EventBus";
export default /*@__PURE__*/ _defineComponent({
    __name: 'WatchlistItem',
    props: {
        item: {},
        watchlist: {}
    },
    emits: [
        'delete',
        'quantity-changed'
    ],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const image = ref(null);
        image.value = (props.item.image && productUtils.createImage(props.item.image, 'small')) || null;
        const quantityConfig = ref(createQuantityConfig());
        const removeItem = ref(null);
        if (isGranted('PORTAL_WATCHLISTS_MANAGE') && permitted("addRemoveItems")) {
            removeItem.value = new RemoveWatchlistItems([props.item.id], props.watchlist.watchlistId);
        }
        const deleted = ref(false);
        const onQuantityChangeDebounced = debounce(onQuantityChange, 300);
        function createQuantityConfig() {
            const orderingUnit = props.item.variant && props.item.variant.orderingUnits
                .find(ou => ou.unitCode === props.item.unitCode)
                || WatchlistUtils.createOrderingUnitForWatchlistItem(props.item);
            return WatchlistUtils.createQuantityConfig(props.item.quantity, orderingUnit, props.item.portions);
        }
        function onCartSubmit() {
            addCartItem({
                sku: props.item.sku,
                quantity: props.item.quantity,
                unit: props.item.unitCode,
                portions: props.item.portions,
            });
        }
        watch(() => props.item.quantity, onItemQuantityChange);
        function onItemQuantityChange() {
            quantityConfig.value = createQuantityConfig();
        }
        function onQuantityChange(quantity) {
            const oldQuantity = props.item.quantity;
            if (quantity.quantity === oldQuantity) {
                return;
            }
            if (!isGranted('PORTAL_WATCHLISTS_MANAGE')) {
                return;
            }
            updateWatchlistItem(props.watchlist.watchlistId, {
                id: props.item.id,
                sku: props.item.sku,
                quantity: quantity.quantity,
                unit: props.item.unitCode,
                portions: quantity.portions,
            })
                .then(item => {
                const diff = item.quantity - oldQuantity;
                if (diff > 0) {
                    const trackingItem = { ...props.item, quantity: diff };
                    events.$emit('track.add_to_wishlist', { affectedItems: [trackingItem] });
                }
                emit('quantity-changed', item);
                quantityConfig.value.initial = item.quantity;
                quantityConfig.value.portions = item.portions;
                quantityConfig.value.unit = item.unitCode;
            });
        }
        function onDelete() {
            deleted.value = true;
            window.setTimeout(() => emit('delete', props.item), 500);
        }
        function permitted(...operation) {
            return WatchlistUtils.permitted(props.watchlist, operation);
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            const _component_icon = _resolveComponent("icon");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["watchlist-item", { 'watchlist-item--deleted': deleted.value }])
            }, [
                _createElementVNode("div", _hoisted_1, [
                    (image.value)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: image.value.url,
                            alt: image.value.title
                        }, null, 8, _hoisted_2))
                        : _createCommentVNode("", true)
                ]),
                _cache[5] || (_cache[5] = _createTextVNode()),
                _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_router_link, {
                        to: { name: 'catalog', query: { sku: __props.item.sku } },
                        class: "watchlist-item__title"
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(__props.item.title), 1)
                        ]),
                        _: 1
                    }, 8, ["to"]),
                    _cache[3] || (_cache[3] = _createTextVNode()),
                    _createElementVNode("span", _hoisted_4, _toDisplayString(__props.item.sku), 1),
                    _cache[4] || (_cache[4] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_5, [
                        (__props.item.variant && permitted('editItems'))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _createVNode(ArticleQuantityInput, {
                                    onChange: _unref(onQuantityChangeDebounced),
                                    available: true,
                                    config: quantityConfig.value,
                                    "display-portions": "top",
                                    "reset-on-cart-item-added": true,
                                    "reset-portions-on-close": false
                                }, null, 8, ["onChange", "config"]),
                                _cache[0] || (_cache[0] = _createTextVNode()),
                                (__props.item.unit && __props.item.unitCode !== 'piece')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$unit(__props.item)), 1))
                                    : _createCommentVNode("", true),
                                _cache[1] || (_cache[1] = _createTextVNode()),
                                _createElementVNode("a", {
                                    onClick: _withModifiers(onCartSubmit, ["prevent"]),
                                    class: "button button--link button--small",
                                    title: _ctx.$t('product.add_to_order'),
                                    href: ""
                                }, [
                                    _createVNode(_component_icon, { name: "cart" })
                                ], 8, _hoisted_8)
                            ]))
                            : _createCommentVNode("", true),
                        _cache[2] || (_cache[2] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_9, [
                            (removeItem.value)
                                ? (_openBlock(), _createBlock(CommandButton, {
                                    key: 0,
                                    command: removeItem.value,
                                    onSuccess: onDelete,
                                    label: '',
                                    classes: ['button', 'button--link', 'button--icon']
                                }, null, 8, ["command"]))
                                : _createCommentVNode("", true)
                        ])
                    ])
                ])
            ], 2));
        };
    }
});
